<template>
  <div>
    <v-content>
      <v-card>
        <v-container fluid grid-list-xl>
          <v-layout row wrap>
            <v-flex v-for="element in elements" v-bind="{ [`md${4}`]: true, [`sm${12}`]: true }" :key="element.uuid">
              <v-card dark class="module_card">
                <!-- <pre>
                    {{element}}
                </pre>-->
                <v-flex v-for="(e,index) in element" v-bind="{ [`sm${12}`]: true }" :key="index">
                  <v-img v-if="index=='raw_map'" :src="e"></v-img>
                  <v-img v-if="index=='heat_map'" :src="e"></v-img>
                  <v-card-actions v-if="index=='bundle'" >
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon>create</v-icon>
                    </v-btn>
                    <v-btn icon :href="e">
                      <v-icon>open_in_browser</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteEle(element)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-content>
  </div>
</template>

<script>
export default {
  props: {
    source: String
  },
  mounted: async function() {
    await this.swithDispatch(this.$route.path);
    await this.getMethodAsync(this.$route.path);
    
  },
  data() {
    return {
      elements: [],
      route_current: this.$route.path
    };
  },
  methods: {
    async getMethodAsync(route) {
      this.elements = await this.getterElements(route);
    },
    enterTo(element) {
      let uuid = element.uuid;
      this.$router.push({
        path: this.route_current + "/" + uuid
      });
    },
    deleteEle(element) {
      
      if (element == null || element == undefined) {
        alert("deleteEle error");
      }
      switch (this.route_current) {
        case "/medias":
          this.$store.dispatch("image/deleteMedia", element.uuid);
          break;
        case "/projects":
          this.$store.dispatch("project/delProject", element.uuid);
          break;
        case "/reports":
          this.$store.dispatch("report/deleteReport", element.uuid);
          break;
        default:
          break;
      }
    },
    async swithDispatch(method) {
      switch (method) {
        case "/medias":
          await this.$store.dispatch("image/getImages");
          break;
        case "/projects":
          await this.$store.dispatch("project/getProjects");
          break;
        case "/reports":
          await this.$store.dispatch("report/getReports");
          break;
        default:
          break;
      }
    },
    async getterElements(name_method) {
      let app = this;
      let elements = null;
      switch (name_method) {
        case "/medias":
          elements = await app.$store.getters["image/getImages"];
          break;
        case "/projects":
          elements = await app.$store.getters["project/getProjectsAnyParent"];
          
          break;
        case "/reports":
          elements = await app.$store.getters["report/getReports"];
          break;
        default:
          break;
      }
      return elements;
    }
  },
  watch: {
    async $route(to, from) {
      await this.swithDispatch(to.path);
      await this.getMethodAsync(to.path);
      this.route_current = to.path;
    }
  }
};
</script>
